import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { Dropdown } from "react-bootstrap";
import Link from "next/link";

export default function NavbarDropdown({ drodownItem, show, title, id, slug }) {
  // const router = useRouter();
  const [isHoverableDevice, setIsHoverableDevice] = useState(false);
  // const [show, setShow] = useState(true);

  // Detect if the device supports hover (i.e. has a mouse)
  useEffect(() => {
    const checkHover = () => {
      const canHover = window.matchMedia(
        "(hover: hover) and (pointer: fine)"
      ).matches;
      const isDesktop = window.innerWidth >= 1400; // Bootstrap lg breakpoint (or adjust)

      // Enable hover only if device supports it AND screen is large
      setIsHoverableDevice(canHover && isDesktop);
    };

    checkHover();
    window.addEventListener("resize", checkHover);
    return () => window.removeEventListener("resize", checkHover);
  }, []);

  return (
    // <div className="navbar-dropdown"
    // onClick={() => router.push(`/${slug}`)}
    // >
    <Dropdown
      show={isHoverableDevice ? true : show}
      className="navbar-dropdown"
    >
      <Dropdown.Toggle
        id={id}
        // as={Link}
        // href={`/${slug}`}
        variant="nav-link"
        className="py-0 "
      >
        <Link
          href={`/${slug}`}
          className="text-capitalize text-decoration-none"
        >
          {title}
        </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu className="pt-0 pt-xxl-3 pb-0 bg-transparent border-0 rounded-0">
        <div className="bg-white py-0 py-xxl-2 rounded-2 custom-drop-menu">
          {drodownItem.map((item, i) => {
            return (
              <Dropdown.Item
                key={i}
                href={item.href}
                className="position-relative"
              >
                <span>{item.name}</span>
                <div className=" position-absolute top-0 bottom-0 start-0 left-layer"></div>
              </Dropdown.Item>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
    // </div>
  );
}
